import { render, staticRenderFns } from "./SubmitApplication.vue?vue&type=template&id=36fde2b4&scoped=true&"
import script from "./SubmitApplication.vue?vue&type=script&lang=js&"
export * from "./SubmitApplication.vue?vue&type=script&lang=js&"
import style0 from "./SubmitApplication.vue?vue&type=style&index=0&id=36fde2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fde2b4",
  null
  
)

export default component.exports